// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationPreview-module__container--3y-Ok","icon":"NotificationPreview-module__icon--15KYp"};